const links = [
  { id: 1, path: '/', text: 'Books' },
  { id: 2, path: '/categories', text: 'Categories' },
];

export default links;
